module.exports = __webpack_public_path__ + "static/media/layout-dashboard.eb375788.svg";